export default __webpack_public_path__ + "static/media/img-1.24d7c20d.jpg";